import { useEffect, useState } from "react";
import { list } from "@/lib/api";
import { CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "@/components/ui/command";
import api from "@/lib/api";

const TYPE_ROUTE = {
  Client: "/clients",
  Event: (r) => `/events/${r.id}`,
  Vendor: "/vendors",
  Team: "/team",
  Invoice: "/invoices",
  Task: "/tasks",
  Document: "/documents",
};

export default function GlobalSearch({ open, onOpenChange, onNavigate }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!q.trim()) { setResults([]); return; }
    const t = setTimeout(() => {
      api.get("/search", { params: { q } }).then((r) => setResults(r.data)).catch(() => setResults([]));
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  const go = (r) => {
    const route = TYPE_ROUTE[r.type];
    onNavigate(typeof route === "function" ? route(r) : route);
    setQ("");
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Cari client, event, vendor, invoice..." value={q} onValueChange={setQ} data-testid="global-search-input" />
      <CommandList>
        <CommandEmpty>{q ? "Tidak ada hasil." : "Ketik untuk mencari..."}</CommandEmpty>
        {results.length > 0 && (
          <CommandGroup heading="Hasil">
            {results.map((r) => (
              <CommandItem key={`${r.type}-${r.id}`} value={`${r.type}-${r.title}-${r.id}`} onSelect={() => go(r)} data-testid="search-result-item">
                <span className="text-xs font-semibold text-gold-dark w-20 shrink-0">{r.type}</span>
                <span className="text-sm">{r.title}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
